export const SET_PAGE_PATH='SET_PAGE_PATH'